import { User } from '@shared/auth/type';
import Notify from '@shared/notify';
import axios, { AxiosInstance } from 'axios';

const createAxiosInstance = (isAuth = true, isMultipart = false, token?: any, userStatus?: any): AxiosInstance => {
    const header: any = {
        Accept: 'application/json',
        'content-Type': isMultipart ? 'multipart/form-data' : 'application/json',
    };
    if (isAuth) {
        if (localStorage.getItem('user') !== null) {
            const userStr = localStorage.getItem('user');
            const user: User = JSON.parse(userStr!);
            header['Authorization'] = token || user?.token || null;
        } else {
            header['Authorization'] = token;
        }
    }

    if (userStatus == false) {
        header['x-user-state'] = 'false';
    }

    const dataObj: any = {
        baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
        headers: header,
        withCredentials: true,
    };

    const instance = axios.create(dataObj);

    // Add an interceptor to dynamically set the Authorization header based on the provided token
    // instance.interceptors.request.use(config => {
    //     return config;
    // });

    // errorComposer will compose a handleGlobally function
    instance.interceptors.response.use(
        function(response: any) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            if (response.headers['x-user-token']) {
                let user: any = localStorage.getItem('user');
                user = JSON.parse(user);
                user.token = response.headers['x-user-token'];
                localStorage.setItem('user', JSON.stringify(user));
            }
            response.headers['x-user-token'] = '';
            return response;
        },
        function(error) {
            try {
                //console.log('error', error);
                const statusCode = error.response ? error.response.status : null;
                if (statusCode == 401) {
                    Notify('error', 'Unauthorized Access');
                    localStorage.clear();
                    window.location.href = '/';
                } else if (statusCode == 422) {
                    notifyError(error?.response?.data?.errors);
                    // Notify('error', error?.response?.data?.message || error?.response?.message || 'Server error');
                } else if (statusCode == 400) {
                    Notify('error', error?.response?.data?.message || error?.response?.message || 'Server error');
                } else {
                    Notify(
                        'error',
                        error?.response?.data?.message || error?.response?.message || 'Oops! Something went wrong',
                    );
                }
                // Do something with response error
                return Promise.reject(error);
            } catch (error) {
                Notify('error', 'Oops! Something went wrong');
            }
        },
    );

    return instance;
};

const notifyError = (errors: any) => {
    try {
        if (Array.isArray(errors) && errors.length > 0) {
            errors.forEach((i: any) => {
                Notify('error', i?.message || 'Oops! Something went wrong');
            });
        }
    } catch (error) {}
};

export default createAxiosInstance;
